import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { Cookie } from 'ng2-cookies';
import { sha256 } from 'js-sha256';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient } from '@angular/common/http';
import { ApiHiEcom } from '../_models/apiInfo';
import { EnvironmentsService } from './enviroment.service';

@Injectable({
  providedIn: 'root',
})
export class WebkitService {
  backUrl: any;
  readonly apiHiEcom = ApiHiEcom;
  readonly emitChangeSource = new Subject<any>();
  changeEmitted$ = this.emitChangeSource.asObservable();
  readonly emitPackageSubject = new BehaviorSubject<any>({});
  packageObservable$ = this.emitPackageSubject.asObservable();
  readonly emitPromotionSubject = new BehaviorSubject<any>({});
  promotionObservable$ = this.emitPromotionSubject.asObservable();
  readonly emitInputPromotionSubject = new BehaviorSubject<any>({});
  promotionInputObservable$ = this.emitInputPromotionSubject.asObservable();
  readonly emitAddressSubject = new BehaviorSubject<any>({});
  addressObservable$ = this.emitAddressSubject.asObservable();
  readonly emitVoucherSubject = new BehaviorSubject<any>({});
  voucherObservable$ = this.emitVoucherSubject.asObservable();
  readonly emitOnmeetingSubject = new BehaviorSubject<any>({});
  onmeetingObservable$ = this.emitOnmeetingSubject.asObservable();
  readonly emitVideoSubject = new BehaviorSubject<any>({});
  videoObservable$ = this.emitVideoSubject.asObservable();
  readonly emitWomenDaySubject = new BehaviorSubject<any>({});
  womenDayObservable$ = this.emitWomenDaySubject.asObservable();
  readonly emitWomenDaySubject2 = new BehaviorSubject<any>({});
  womenDayObservable2$ = this.emitWomenDaySubject2.asObservable();
  readonly emitWomenDaySubject3 = new BehaviorSubject<any>({});
  womenDayObservable3$ = this.emitWomenDaySubject3.asObservable();
  readonly emitMarathonSubject = new BehaviorSubject<any>({});
  marathonObservable$ = this.emitMarathonSubject.asObservable();
  readonly emitLuxInternetSubject = new BehaviorSubject<any>({});
  luxInternetObservable$ = this.emitLuxInternetSubject.asObservable();
  readonly emitLoyaltySubject = new BehaviorSubject<any>({});
  fptLoyaltyObservable$ = this.emitLoyaltySubject.asObservable();
  constructor(
    readonly jwtHelper: JwtHelperService,
    readonly http: HttpClient,
    readonly envService: EnvironmentsService
  ) {
    this.backUrl = envService.apiUrl;
  }

  // getToken(token: any): any {
  //   const arr = new ReplaySubject(1);
  //   const headers = { TOKEN: token };
  //   const content = {};
  //   Cookie.delete('webkit_token');
  //   this.http
  //     .post<any>(this.backUrl + this.apiHiEcom.auth, content, { headers })
  //     .subscribe(
  //       (res) => {
  //         if (res && res.status === 1) {
  //           const dt = this.jwtHelper.decodeToken(res.token);
  //           const accessToken = res.token;
  //           if (dt.customerId) {
  //             const infoClient = {
  //               customer_id: dt.customerId,
  //               fullname: dt.fullname,
  //               phone_nb: dt.phone,
  //               address: dt.address,
  //               is_account_test: dt.is_account_test,
  //               version_app: dt.appVersion,
  //               list_contract: dt.listContract,
  //             };
  //             Cookie.set('webkit_token', accessToken);
  //             Cookie.set(
  //               'webkit_info',
  //               btoa(unescape(encodeURIComponent(JSON.stringify(infoClient))))
  //             );
  //             arr.next('ok');
  //           }
  //         } else {
  //           arr.next('not_ok');
  //           Cookie.delete('webkit_token');
  //           Cookie.delete('webkit_info');
  //           this.expireTokenHifpt();
  //         }
  //       },
  //       (error) => {
  //         arr.next('not_ok');
  //         Cookie.delete('webkit_token');
  //         Cookie.delete('webkit_info');
  //         this.expireTokenHifpt();
  //       }
  //     );
  //   return arr;
  // }
  getToken(token: any, screenId?: any): any {
    const arr = new ReplaySubject(1);
    const headers = { TOKEN: token };
    const content = screenId ? { screenId } : {};
    Cookie.delete('webkit_token');
    this.http
      .post<any>(this.backUrl + this.apiHiEcom.auth, content, { headers })
      .subscribe(
        (res) => {
          if (res && res.status === 1) {
            const dt = this.jwtHelper.decodeToken(res.token);
            const accessToken = res.token;
            if (dt.customerId) {
              const infoClient = {
                customer_id: dt.customerId,
                fullname: dt.fullname,
                phone_nb: dt.phone,
                address: dt.address,
                is_account_test: dt.is_account_test,
                version_app: dt.appVersion,
                list_contract: dt.listContract,
              };
              Cookie.set('webkit_token', accessToken);
              Cookie.set(
                'webkit_info',
                btoa(unescape(encodeURIComponent(JSON.stringify(infoClient))))
              );
              arr.next('ok');
            }
          } else {
            arr.next('not_ok');
            Cookie.delete('webkit_token');
            Cookie.delete('webkit_info');
            this.expireTokenHifpt();
          }
        },
        (error) => {
          arr.next('not_ok');
          Cookie.delete('webkit_token');
          Cookie.delete('webkit_info');
          this.expireTokenHifpt();
        }
      );
    return arr;
  }
  getInfoUser(): any {
    if (Cookie.get('webkit_info')) {
      return JSON.parse(
        decodeURIComponent(escape(atob(Cookie.get('webkit_info'))))
      );
    } else {
      return null;
    }
  }

  checkSum(value: any): any {
    const a = value;
    const hash = sha256.create();
    hash.update(a);
    hash.hex();
    return hash.hex();
  }

  checkToken(): any {
    return Cookie.check('webkit_token');
  }

  getMobileFcToken(): any {
    return Cookie.get('webkit_token');
  }

  callToken(): any {
    // @ts-ignore
    if (window.AndroidBridge) {
      // @ts-ignore
      window.AndroidBridge.callbackToApp('{"action" : "getToken"}');
      // @ts-ignore
    } else if (window.webkit && window.webkit.messageHandlers) {
      // @ts-ignore
      window.webkit.messageHandlers.callbackToApp.postMessage(
        '{"action" : "getToken"}'
      );
    }
  }
  callAppFunction(str: any): any {
    console.log(str);
    // @ts-ignore
    if (window.AndroidBridge) {
      // @ts-ignore
      window.AndroidBridge.callbackToApp(str);
      // @ts-ignore
    } else if (window.webkit && window.webkit.messageHandlers) {
      // @ts-ignore
      window.webkit.messageHandlers.callbackToApp.postMessage(str);
    }
  }
  sharedAppFunction(): any {
    const a = {
      action: 'shareApp',
      data: '',
    };
    // @ts-ignore
    if (window.AndroidBridge) {
      a.data =
        'https://play.google.com/store/apps/details?id=com.rad.hifpt&hl=vi';
      // @ts-ignore
      window.AndroidBridge.callbackToApp(JSON.stringify(a));
      // @ts-ignore
    } else if (window.webkit && window.webkit.messageHandlers) {
      a.data = 'https://apps.apple.com/vn/app/hi-fpt/id1144417173';
      // @ts-ignore
      window.webkit.messageHandlers.callbackToApp.postMessage(
        JSON.stringify(a)
      );
    }
  }
  installingApp(): any {
    // @ts-ignore
    if (window.AndroidBridge) {
      // @ts-ignore
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.rad.hifpt&hl=vi';
      // @ts-ignore
    } else if (window.webkit && window.webkit.messageHandlers) {
      // @ts-ignore
      window.location.href =
        'https://itunes.apple.com/vn/app/hi-fpt/id1144417173?l=vi&mt=8';
    }
  }
  directionApp(p: any): any {
    if (p.mission_type === 'NAVIGATE_SCREEN') {
      this.directionCallApp(p.mission_action);
    } else if (p.mission_type === 'REDIRECT_LINK') {
      this.directionCallAppWithLink(this.envService.domain + p.mission_action);
    } else if (p.mission_type === 'SHARE') {
      this.sharedAppFunction();
    } else if (p.mission_type === 'GO_HOME') {
      this.goHome();
    }
  }
  directionCallApp(str: any): any {
    const a = {
      action: 'callScreen',
      data: null,
      actionType: 'go_to_screen',
      title: '',
      dataAction: str,
    };
    this.callAppFunction(JSON.stringify(a));
  }
  directionCallAppWithLink(str: any): any {
    const a = {
      action: 'callScreen',
      data: null,
      actionType: 'open_url_in_app_with_access_token',
      title: '',
      dataAction: str,
    };
    this.callAppFunction(JSON.stringify(a));
  }

  expireTokenHifpt(): any {
    // @ts-ignore
    if (window.AndroidBridge) {
      // @ts-ignore
      window.AndroidBridge.callbackToApp('{"action" : "tokenExpire"}');
      // @ts-ignore
    } else if (window.webkit.messageHandlers) {
      // @ts-ignore
      window.webkit.messageHandlers.callbackToApp.postMessage(
        '{"action" : "tokenExpire"}'
      );
    }
  }
  callCamera(): any {
    // @ts-ignore
    if (window.AndroidBridge) {
      // @ts-ignore
      window.AndroidBridge.callbackToApp('{"action" : "callCamera"}');
      // @ts-ignore
    } else if (window.webkit.messageHandlers) {
      // @ts-ignore
      window.webkit.messageHandlers.callbackToApp.postMessage(
        '{"action" : "callCamera"}'
      );
    }
  }
  goHome(): any {
    Cookie.delete('webkit_token');
    // @ts-ignore
    if (window.AndroidBridge) {
      // @ts-ignore
      window.AndroidBridge.surveyAction('{"action" : "backHome"}');
      // @ts-ignore
    } else if (window.webkit.messageHandlers) {
      // @ts-ignore
      window.webkit.messageHandlers.surveyAction.postMessage(
        '{"action" : "backHome"}'
      );
    }
  }
  goBackHome(): any {
    Cookie.delete('webkit_token');
    // @ts-ignore
    if (window.AndroidBridge) {
      // @ts-ignore
      window.AndroidBridge.callbackToApp('{"action" : "Home"}');
      // @ts-ignore
    } else if (window.webkit.messageHandlers) {
      // @ts-ignore
      window.webkit.messageHandlers.callbackToApp.postMessage(
        '{"action" : "Home"}'
      );
    }
  }
  getWebToken() {
    //  return '790bc6f2-1485-4abc-937a-75afb9fbf8f6';
    return sessionStorage.getItem('token_code')
      ? sessionStorage.getItem('token_code')
      : '';
  }
  returnHeader(): any {
    return { TOKEN: this.getWebToken() };
  }
}
export const patternName =
  '^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\\s\\W|_]+$';
export const patternAddress =
  '^[0-9a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\\s\\W|_().,/]+$';
